module.exports = "/build/web/svg/eredivisie.aa34fb355a566a9ff848096a3fde0b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/eredivisie.svg
// module id = 155
// module chunks = 24